
import { Flexi } from "slotworks/graphics/elements/abstract-flexi";
import SliderElement from "slotworks/graphics/elements/slider-element";

export default class FlexiSlider extends Flexi<HTMLElement | SliderElement> {

    private value: number;

    public addTarget(target: HTMLElement | SliderElement) {
        super.addTarget(target);

        if (target) {
            if (target instanceof HTMLElement) {
                const slider = target as HTMLInputElement;
                slider.addEventListener("input", this.handleDOMInput);
            } else {
                target.onInput.add(this.updateValue);
            }
        }
    }

    public destroy() {
        super.destroy();

        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.removeEventListener("input", this.handleDOMInput);
            } else {
                target.onChange.removeAll();
            }
        }
    }

    public on(event: SliderEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.addEventListener(event.id, handler as any);
            } else {
                if (event === SliderEvent.INPUT) {
                    target.onInput.add(handler);
                } else if (event === SliderEvent.CHANGE) {
                    target.onChange.add(handler);
                }
            }
        }
    }

    public off(event: SliderEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.removeEventListener(event.id, handler as any);
            } else {
                if (event === SliderEvent.INPUT) {
                    target.onInput.remove(handler);
                } else if (event === SliderEvent.CHANGE) {
                    target.onChange.remove(handler);
                }
            }
        }
    }

    public setMin(value: number) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                (target as HTMLInputElement).min = value.toString();
            } else {
                target.setMin(value);
            }
        }
    }

    public setMax(value: number) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                (target as HTMLInputElement).max = value.toString();
            } else {
                target.setMax(value);
            }
        }
    }

    public setValue(value: number) {
        this.updateValue(value);

        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                (target as HTMLInputElement).value = value.toString();
            } else {
                target.setValue(value);
            }
        }
    }

    public getValue(): number {
        return this.value;
    }

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("visible", visible);
                target.classList.toggle("hidden", !visible);
            } else {
                target.setVisible(visible);
            }
        }
    }

    public setEnabled(enabled: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("enabled", enabled);
                target.classList.toggle("disabled", !enabled);
            } else {
                target.setEnabled(enabled);
            }
        }
    }

    private handleDOMInput = (e: any) => {
        this.updateValue(parseFloat(e.target.value));
    }

    private updateValue = (value: number) => {
        this.value = value;
    }
}

export class SliderEvent {
    public static CHANGE: SliderEvent = new SliderEvent("change");
    public static INPUT: SliderEvent = new SliderEvent("input");

    public id: string;

    constructor(id: string) {
        this.id = id;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/flexi-slider.ts